export const messages = {
  en: {
    nav: {
      home: 'Home',
      products: 'Products',
      about: 'About',
      news: 'FAQ',
      contact: 'Contact',
      quote: 'Get quote',
      search: 'Search'
    },
    common: {
      home: 'Home',
      loading: 'Loading…',
      send: 'Send',
      sending: 'Sending…',
      viewMore: 'View more',
      product: 'Product',
      detail: 'Detail',
      all: 'All',
      introduction: 'Introduction',
      backToProducts: '← Back to products',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      productImages: 'Product images',
      previewImage: 'View larger image',
      closePreview: 'Close preview'
    },
    home: {
      expoNoticeTitle: 'Explore the Boris Product Range',
      viewAllProducts: 'View all our products',
      whyChooseUs: 'The Difference Between Boris And A Standard Bag Factory',
      aboutParagraphs: [
        "Thank you for your interest in Boris Bags Limited It's my great pleasure to introduce our factory",
        'Boris is a bag manufacturer. We have over 10 years of rich experience in bags. Our company is located in YIWU City, Zhejiang Province, China. OEM or ODM are available.',
        'Our Products: Our main products are Backpacks, School bags, Diaper Bags, Cooler bags, Beach Bags etc.',
        'Our Advantage: Located in China mainland, lower land charge and labor fee help us provide competitive prices. Years of experience and cooperation with reputable companies give us confidence to deliver high-quality products.',
        'Our Mission: Quality, Service, and innovation are our mission. We believe you will find our Quality, Service, and Innovation satisfying — not only in our selection of bags but also in our personnel. Trust us as your supplier and partner in China.'
      ],
      whyItems: [
        {
          title: 'Innovation',
          icon: 'fa fa-cog',
          body: 'Boris Bags has a strong design team to develop new models and support OEM/ODM projects.'
        },
        {
          title: 'High quality',
          icon: 'fa fa-search',
          body: 'Complete quality control from incoming materials through assembly, packing, inspection and shipment.'
        },
        {
          title: 'Competitive price',
          icon: 'fa fa-heart fas',
          body: 'Efficient production in China helps us offer favorable pricing without compromising quality.'
        },
        {
          title: 'Stable lead time',
          icon: 'fa fa-bolt',
          body: 'Strict production scheduling ensures each order runs smoothly and delivers on time.'
        },
        {
          title: 'Reliable Warranty',
          icon: 'fa fa-fast-forward',
          body: 'We stand behind our products and respond to your requests promptly.'
        },
        {
          title: 'Professional Service',
          icon: 'fa fa-user fas',
          body: 'Experienced sales team provides professional advice and dedicated support.'
        }
      ]
    },
    about: {
      title: 'About',
      sectionTitle: 'Company introduction',
      intro:
        "Thank you for your interest in Boris Bags Limited It's my great pleasure to introduce our factory.",
      bullets: [
        'Boris is a professional manufacturer specializing in backpack production. With a factory area of approximately 3,000 square meters, we have built a streamlined production system to ensure efficient and high-quality manufacturing.',
        'Our product range covers 4 core backpack series, tailored to meet diverse market demands such as daily commute, outdoor travel, and student use. Boasting a daily production capacity of 500 units, we are capable of fulfilling both bulk orders and customized requirements promptly.​',
        'Quality control is the cornerstone of our operations. We implement strict inspection procedures throughout the entire production process—from raw material selection to cutting, sewing, assembly, and final packaging.',
        'Committed to providing reliable products and professional services, Boris looks forward to establishing long-term cooperative relationships with partners worldwide.'
      ],
      contactTeam: 'Contact our lovely team',
      viewProducts: 'View our interesting products'
    },
    products: {
      title: 'Products',
      filtersLabel: 'Product filters',
      loading: 'Loading products…',
      empty: 'No products in this category yet.',
      loadError: 'Failed to load products.'
    },
    productDetail: {
      loading: 'Loading product…',
      loadError: 'Product not found.',
      notFound: 'Product not found.',
      noDescription: 'No description available.'
    },
    news: {
      title: 'FAQ',
      intro: 'Frequently asked questions — click a title to read more.',
      loading: 'Loading FAQ…',
      empty: 'No FAQ entries yet.',
      loadError: 'Failed to load FAQ.',
      back: 'Back to FAQ',
      orderNotice: {
        title: 'Order Notice',
        customizationTitle: 'Customization',
        customizationItems: [
          'Customized logo (Min. Order: 300 Pieces)',
          'Customized packaging (Min. Order: 300 Pieces)',
          'Graphic customization (Min. Order: 300 Pieces)'
        ],
        deliveryTitle: 'Delivery time',
        deliveryText: '7 days for sample, 15-30 days for mass production.',
        paymentTitle: 'Payment Term',
        paymentItems: [
          'T/T (Telegraphic transfer)',
          'WesternUnion',
          'Paypal (only for sample), the amount below USD1000, additional transactions fee 5% will be charged.'
        ]
      }
    },
    contact: {
      title: 'Contact',
      companyName: 'Boris Bags Limited',
      address: 'No. 11379-11380, Lane 12, Gate 30, Zone F1, Yiwu International Trade City',
      whatsappLabel: 'Wechat/WhatsApp: +86 18273950322'
    },
    footer: {
      recentProducts: 'Recent products',
      inquiry: 'Send us your inquiry',
      categories: 'Product category',
      contactInfo: 'Contact Info',
      phone: 'Phone',
      whatsapp: 'WhatsApp',
      email: 'Email',
      web: 'Web',
      briefIntro: 'Boris introduction',
      briefIntroText:
        'Boris is a professional manufacturer specializing in backpack production. With a factory area of approximately 3,000 square meters, we have built a streamlined production system to ensure efficient and high-quality manufacturing.',
      copyright: 'Copyright {years} Boris Bags © All rights Reserved.'
    },
    form: {
      pageHint: 'We will answer your email shortly!',
      name: 'Your name*',
      email: 'Email Address*',
      website: 'Your website*',
      message: 'Give us your need as specific as possible*',
      fixErrors: 'Please correct the errors above.',
      success:
        'Thank you! Your inquiry has been saved. Your email app should open — please click Send there to deliver your message to info@borisbags.com.',
      submitError: 'Failed to submit. Please try again later.',
      errors: {
        name: 'Please enter your name.',
        email: 'Please enter your email address.',
        emailInvalid: 'Please enter a valid email address.',
        website: 'Please enter your website.',
        message: 'Please enter your message.'
      }
    },
    whatsapp: {
      aria: 'Chat on WhatsApp'
    },
    slider: {
      loading: 'Loading…'
    },
    pageTitle: {
      home: 'Boris Bags',
      contact: 'Contact - Boris Bags',
      about: 'About - Boris Bags',
      products: 'Products - Boris Bags',
      news: 'FAQ - Boris Bags',
      product: 'Product - Boris Bags'
    }
  },
  zh: {
    nav: {
      home: '首页',
      products: '产品',
      about: '关于我们',
      news: '常见问题',
      contact: '联系我们',
      quote: '获取报价',
      search: '搜索'
    },
    common: {
      home: '首页',
      loading: '加载中…',
      send: '发送',
      sending: '发送中…',
      viewMore: '查看更多',
      product: '产品',
      detail: '详情',
      all: '全部',
      introduction: '产品介绍',
      backToProducts: '← 返回产品列表',
      previousImage: '上一张',
      nextImage: '下一张',
      productImages: '产品图片',
      previewImage: '查看大图',
      closePreview: '关闭预览'
    },
    home: {
      expoNoticeTitle: '探索 Boris 产品系列',
      viewAllProducts: '查看全部产品',
      whyChooseUs: 'Boris 与一般箱包工厂的区别',
      aboutParagraphs: [
        '感谢您对 Boris Bags Limited 的关注，很高兴向您介绍我们的工厂。',
        'Boris 是一家包袋制造商，在包袋领域拥有超过 10 年丰富经验。公司位于中国浙江省义乌市，支持 OEM 与 ODM。',
        '主要产品：背包、书包、妈咪包、保温袋、沙滩包等。',
        '我们的优势：位于中国大陆，土地与人力成本更具竞争力，多年行业经验及与众多知名企业的合作，使我们有信心为您提供高品质产品。',
        '我们的使命：品质、服务与创新。我们相信您会对我们的品质、服务与创新感到满意——不仅体现在丰富的包袋品类，也体现在我们的团队。期待成为您在中国值得信赖的供应商与伙伴。'
      ],
      whyItems: [
        {
          title: '创新设计',
          icon: 'fa fa-cog',
          body: 'Boris Bags 拥有专业设计团队，持续开发新款，支持 OEM/ODM 定制。'
        },
        {
          title: '高品质',
          icon: 'fa fa-search',
          body: '从来料、组装、包装、检验到出货，建立完整的品质管控体系。'
        },
        {
          title: '有竞争力的价格',
          icon: 'fa fa-heart fas',
          body: '依托中国制造的高效产能，在保障品质的同时提供更具优势的价格。'
        },
        {
          title: '稳定交期',
          icon: 'fa fa-bolt',
          body: '严格的生产排程，确保订单顺畅推进、按时交付。'
        },
        {
          title: '可靠保障',
          icon: 'fa fa-fast-forward',
          body: '我们对产品品质负责，并快速响应您的需求。'
        },
        {
          title: '专业服务',
          icon: 'fa fa-user fas',
          body: '经验丰富的销售团队，为您提供专业建议与完善服务。'
        }
      ]
    },
    about: {
      title: '关于我们',
      sectionTitle: '公司介绍',
      intro: '感谢您对 Boris Bags Limited 的关注，很高兴向您介绍我们的工厂。',
      bullets: [
        'Boris 是一家专注于背包生产的专业制造商，工厂面积约 3000 平方米，建立了高效流畅的生产体系，确保高品质制造。',
        '我们的产品系列涵盖四大核心背包系列，旨在满足日常通勤、户外旅行​​和学生使用等多样化的市场需求。我们拥有日产500个背包的产能，能够迅速满足批量订单和定制需求。',
        '品质管控是我们运营的核心。从原材料选购、裁剪、车缝、组装到最终包装，每个环节都实施严格检验。',
        'Boris 致力于提供可靠的产品与专业的服务，期待与全球合作伙伴建立长期合作关系。'
      ],
      contactTeam: '联系我们的团队',
      viewProducts: '查看我们的产品'
    },
    products: {
      title: '产品',
      filtersLabel: '产品筛选',
      loading: '加载产品中…',
      empty: '该分类下暂无产品。',
      loadError: '加载产品失败。'
    },
    productDetail: {
      loading: '加载产品中…',
      loadError: '未找到该产品。',
      notFound: '未找到该产品。',
      noDescription: '暂无产品介绍。'
    },
    news: {
      title: '常见问题',
      intro: '常见问题解答 — 点击标题阅读全文。',
      loading: '加载中…',
      empty: '暂无内容。',
      loadError: '加载失败。',
      back: '返回常见问题',
      orderNotice: {
        title: '订单须知',
        customizationTitle: '定制服务',
        customizationItems: [
          '定制 Logo（最低起订量：300 件）',
          '定制包装（最低起订量：300 件）',
          '图案定制（最低起订量：300 件）'
        ],
        deliveryTitle: '交货时间',
        deliveryText: '样品 7 天，大货 15–30 天。',
        paymentTitle: '付款方式',
        paymentItems: [
          'T/T（电汇）',
          'Western Union（西联汇款）',
          'PayPal（仅限样品），金额低于 1000 美元时，另收 5% 手续费。'
        ]
      }
    },
    contact: {
      title: '联系我们',
      companyName: 'Boris Bags Limited',
      address: '浙江省义乌市国际商贸城 F1 区 30 号门 12 弄 11379-11380 号',
      whatsappLabel: '微信/WhatsApp：+86 18273950322'
    },
    footer: {
      recentProducts: '最新产品',
      inquiry: '发送询盘',
      categories: '产品分类',
      contactInfo: '联系方式',
      phone: '电话',
      whatsapp: 'WhatsApp',
      email: '邮箱',
      web: '网站',
      briefIntro: '简介',
      briefIntroText:
        'Boris 是一家专注于背包生产的专业制造商，工厂面积约 3000 平方米，建立了高效流畅的生产体系，确保高品质制造。',
      copyright: 'Copyright {years} Boris Bags © 保留所有权利。'
    },
    form: {
      pageHint: '我们会尽快回复您的邮件！',
      name: '您的姓名*',
      email: '电子邮箱*',
      website: '您的网站*',
      message: '请尽可能详细描述您的需求*',
      fixErrors: '请修正上方错误后再提交。',
      success:
        '感谢您的询盘，信息已保存。即将打开邮件客户端，请在邮件中点击发送，将消息发送至 info@borisbags.com。',
      submitError: '提交失败，请稍后重试。',
      errors: {
        name: '请输入您的姓名。',
        email: '请输入电子邮箱。',
        emailInvalid: '请输入有效的电子邮箱。',
        website: '请输入您的网站。',
        message: '请输入留言内容。'
      }
    },
    whatsapp: {
      aria: '通过 WhatsApp 联系我们'
    },
    slider: {
      loading: '加载中…'
    },
    pageTitle: {
      home: 'Boris Bags',
      contact: '联系我们 - Boris Bags',
      about: '关于我们 - Boris Bags',
      products: '产品 - Boris Bags',
      news: '常见问题 - Boris Bags',
      product: '产品 - Boris Bags'
    }
  }
}
